import { gql } from '@anyx/common-graphql';

export const BASIC_USER_FIELDS = gql(/* GraphQL */ `
  fragment BasicUserFields on BasicUser {
    id
    name
    firstName
    lastName
    __typename
  }
`);

export const CUSTOMER_CREATED_CHANNEL_FIELDS = gql(/* GraphQL */ `
  fragment CustomerCreatedChannelFields on CustomerCreatedChannel {
    ... on CustomerCreatedMessagingChannel {
      __typename
      chatType
    }
    ... on CustomerCreatedSaleChannel {
      __typename
      saleChannel
    }
  }
`);

export const MESSAGE_AUTHOR_FIELDS = gql(/* GraphQL */ `
  fragment MessageAuthorFields on MessageAuthor {
    ... on AIAuthor {
      __typename
    }
    ... on AutoAuthor {
      __typename
    }
    ... on BasicUser {
      id
      name
      firstName
      lastName
    }
    __typename
  }
`);

export const CUSTOMER_NOTE_FIELDS_FRAGMENT = gql(/* GraphQL */ `
  fragment CustomerNoteFields on CustomerNote {
    id
    text
    channel {
      ...CustomerCreatedChannelFields
    }
    createdAt
    updatedAt
    user {
      __typename
      id
      name
      firstName
      lastName
    }
  }
`);

export const CUSTOMER_ACTIVITY_V4_CUSTOMER_CREATED = gql(/* GraphQL */ `
  fragment CustomerActivityV4_CustomerCreated on CustomerCreatedActivityV4 {
    channel {
      ...CustomerCreatedChannelFields
    }
  }
`);

export const CUSTOMER_ACTIVITY_V4_INFLUENCER_JOINED_CAMPAIGN = gql(/* GraphQL */ `
  fragment CustomerActivityV4_InfluencerJoinedCampaign on InfluencerJoinedCampaignActivityV4 {
    campaignName
    campaignUrl
  }
`);

export const CUSTOMER_ACTIVITY_V4_INFLUENCER_PUBLISHED_POST = gql(/* GraphQL */ `
  fragment CustomerActivityV4_InfluencerPublishedPost on InfluencerPublishedPostActivityV4 {
    campaignName
    campaignUrl
  }
`);

export const CUSTOMER_ACTIVITY_V4_INFLUENCER_SUBMITTED_POST = gql(/* GraphQL */ `
  fragment CustomerActivityV4_InfluencerSubmittedPost on InfluencerSubmittedPostActivityV4 {
    campaignName
    campaignUrl
  }
`);

export const CUSTOMER_ACTIVITY_V4_OPT_IN = gql(/* GraphQL */ `
  fragment CustomerActivityV4_OptIn on OptInActivityV4 {
    title
    chatType
    optInOperation
  }
`);

export const CUSTOMER_ACTIVITY_V4_ORDERED = gql(/* GraphQL */ `
  fragment CustomerActivityV4_Ordered on OrderedActivityV4 {
    externalOrderId
    anyXRelativeUrl
    saleChannel
  }
`);

export const CUSTOMER_ACTIVITY_V4_PROFILE_UPDATED = gql(/* GraphQL */ `
  fragment CustomerActivityV4_ProfileUpdated on ProfileUpdatedActivityV4 {
    id
    user {
      ...BasicUserFields
    }
  }
`);
